import component from './UiBtn.vue'
export default component
